import moment from 'moment';
import { BILLING_INVOICES } from '../../data/billing-invoices';
import { BillingInvoices, Invoice } from '../../model/billing-invoice';

export class BillingInvoicesMapper {
  static toBillingInvoices(api: any): BillingInvoices {
    return {
      // Details of the last billing
      id: 1, 
      billingInformation: BILLING_INVOICES[0].billingInformation, 

      // Invoice history
      invoices: {
        data: api.invoices.data.map(
          (i: any): Invoice => ({
            id: i.id,
            coverageStartDate: moment(i.coverageStartDate),
            coverageEndDate: moment(i.coverageEndDate),
            planType: i.plan.type,
            billingInterval: i.plan.frequency,
            status: i.status,
            amount: i.amount,
          })
        ),
        meta: api.invoices.meta,
      },
    };
  }
}
